import { FaAccessibleIcon, FaGg } from "react-icons/fa";
import { SiDatabricks } from "react-icons/si";
import { MdConnectWithoutContact } from "react-icons/md";

export const FeatureList = [
  {
    id: 1,
    icon: <FaAccessibleIcon color="#4b4586" size={22} />,
    heading: "Networking",
    text: "Connect with key decision-makers, influencers, and potential partners within the mining industry while increasing your visibility and establishing yourself as a thought leader in the field. "
  },
  {
    id: 2,
    icon: <SiDatabricks color="#4b4586" size={22} />,
    heading: "Latest Innovations",
    text: "Keep up-to-date with the latest advancements in mining technology, sustainable practices, and industry regulations while staying ahead of your competitors by understanding the latest industry developments.",
  },
  {
    id: 3,
    icon: <MdConnectWithoutContact color="#4b4586" size={22} />,
    heading: "Business Opportunities",
    text: "Connect with companies that can complement your business or offer new opportunities while discovering investment opportunities within the mining sector or related industries.",
  },
  {
    id: 4,
    icon: <FaGg color="#4b4586" size={22} />,
    heading: "Growth in Mining Sectors",
    text: "Contribute to the sustainable and responsible development of the African mining industry while advocating for ethical and sustainable mining practices that benefit both the industry and the communities it operates in. ",
  },
];
